export const LISTAHALLAZGO_LOADING = 'modalHallazgos/LISTAHALLAZGO_LOADING';
export const LISTAHALLAZGO_SUCCESS = 'modalHallazgos/LISTAHALLAZGO_SUCCESS';
export const LISTAHALLAZGO_FAILURE = 'modalHallazgos/LISTAHALLAZGO_FAILURE';
